module.exports = __webpack_public_path__ + "images/370ff4360411de061ec6e4843e6a48c34.png";